import ThemeConfig from "@mobiusjs/homme-site-client/dist/ClientThemeConfig";

export default ThemeConfig.customize(ThemeConfig, {
    styles: ['fonts/fonts', 'splide', 'theme'],
    scripts: ['runtime', 'common', 'lib1', 'lib2', 'lib3', 'lib5', 'theme']
});
